export default function Attendance() {
    return (
      <div className="p-6 w-full">
  
        {/* PAGE TITLE */}
        <h1 className="text-2xl font-semibold mb-6">Attendance</h1>
  
        {/* TOP CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
  
          <div className="bg-white rounded-2xl p-5 shadow-sm border">
            <p className="text-sm text-gray-500">Present Today</p>
            <h2 className="text-2xl font-semibold mt-2">42</h2>
          </div>
  
          <div className="bg-white rounded-2xl p-5 shadow-sm border">
            <p className="text-sm text-gray-500">Absent Today</p>
            <h2 className="text-2xl font-semibold mt-2">8</h2>
          </div>
  
          <div className="bg-white rounded-2xl p-5 shadow-sm border">
            <p className="text-sm text-gray-500">Late Check-ins</p>
            <h2 className="text-2xl font-semibold mt-2">5</h2>
          </div>
  
          <div className="bg-white rounded-2xl p-5 shadow-sm border">
            <p className="text-sm text-gray-500">On Leave</p>
            <h2 className="text-2xl font-semibold mt-2">3</h2>
          </div>
  
        </div>
  
        {/* ATTENDANCE TABLE */}
        <div className="bg-white rounded-2xl p-6 shadow-sm border">
          <h2 className="text-lg font-semibold mb-4">Today’s Attendance</h2>
  
          <table className="w-full text-left text-gray-700">
            <thead>
              <tr className="border-b text-sm text-gray-500">
                <th className="py-3">Employee</th>
                <th className="py-3">Department</th>
                <th className="py-3">Check-in</th>
                <th className="py-3">Check-out</th>
                <th className="py-3">Status</th>
              </tr>
            </thead>
  
            <tbody className="text-sm">
  
              <tr className="border-b hover:bg-gray-50">
                <td className="py-3 font-medium">Amit Sharma</td>
                <td>Development</td>
                <td>09:05 AM</td>
                <td>—</td>
                <td>
                  <span className="px-3 py-1 rounded-full bg-yellow-100 text-yellow-700">
                    Late
                  </span>
                </td>
              </tr>
  
              <tr className="border-b hover:bg-gray-50">
                <td className="py-3 font-medium">Priya Patel</td>
                <td>HR</td>
                <td>08:55 AM</td>
                <td>—</td>
                <td>
                  <span className="px-3 py-1 rounded-full bg-green-100 text-green-700">
                    Present
                  </span>
                </td>
              </tr>
  
              <tr className="border-b hover:bg-gray-50">
                <td className="py-3 font-medium">Rahul Verma</td>
                <td>Design</td>
                <td>—</td>
                <td>—</td>
                <td>
                  <span className="px-3 py-1 rounded-full bg-red-100 text-red-700">
                    Absent
                  </span>
                </td>
              </tr>
  
              <tr className="hover:bg-gray-50">
                <td className="py-3 font-medium">Neha Singh</td>
                <td>Marketing</td>
                <td>On Leave</td>
                <td>—</td>
                <td>
                  <span className="px-3 py-1 rounded-full bg-blue-100 text-blue-700">
                    Leave
                  </span>
                </td>
              </tr>
  
            </tbody>
          </table>
        </div>
  
      </div>
    );
  }
  